import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; 
import "./Sidebar.css";
import Logo from "../imgs/logo.png";
import { UilSignOutAlt, UilBars } from "@iconscout/react-unicons";
import { SidebarData } from "../Data/Data";
import { motion } from "framer-motion";

const Sidebar = ({ setIsAuthenticated }) => {
  const location = useLocation(); 
  const navigate = useNavigate(); 
  const [expanded, setExpanded] = useState(() => window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setExpanded(true);
      } else {
        setExpanded(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sidebarVariants = {
    true: { left: "0" },
    false: { left: "-60%" },
  };

  return (
    <>
    
      {window.innerWidth <= 768 && !expanded && (
        <div
          className="bars"
          style={{ left: "5%" }}
          onClick={() => setExpanded(true)}
        >
          <UilBars />
        </div>
      )}

      <motion.div
        className="sidebar"
        variants={sidebarVariants}
        animate={window.innerWidth <= 768 ? `${expanded}` : ""}
      >
        <div className="logo">
          <img src={Logo} alt="logo" />
          <span>
            Sh<span>o</span>ps
          </span>
        </div>

        <div className="menu">
          {SidebarData.map((item, index) => (
            <div
              key={index}
              className={location.pathname === item.link ? "menuItem active" : "menuItem"}
              onClick={() => {
                navigate(item.link);
                if (window.innerWidth <= 768) {
                  setExpanded(false); 
                }
              }}
            >
              <item.icon />
              <span>{item.heading}</span>
            </div>
          ))}

          <div
            className="menuItem-logout"
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("username");
              localStorage.removeItem("currencySymbol");
              localStorage.removeItem("currencySymbolTime");

              setIsAuthenticated(false);
              navigate("/");
            }}
          >
            <UilSignOutAlt />
            <span>Logout</span>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;
